// @flow
export function convertFormRematchResponseFromApi(
  response: Object
) {
  return response.response;
}
